import React, { useContext } from 'react'

import './Filter.css'
import { Row, Col, Form, Label, Input, Button } from 'reactstrap'
import GroupEventCard from '../card/GroupEventCard'
import { SPContext } from '../../SPContext'

const scrollToFilters = () => {
    const target = document.querySelector('.sp-filter')
    const coords = target.getBoundingClientRect()
    if (coords.top > 0) {
        // only do it if the top of section is below the top border of the viewport
        window.scrollTo({
            top: parseInt(coords.top) + parseInt(window.scrollY),
            behavior: 'smooth',
        })
    }
}
const alpha = (a, b) => {
    if (a.label > b.label) {
        return 1
    } else {
        return -1
    }
}
const Filter = React.memo(() => {
    const {
        categories,
        locations,
        event_status,
        filter,
        setFilter,
        sort,
        setSort,
        inAdminPage,
    } = useContext(SPContext)
    // console.log({ filter }, { categories }, { locations }, { sort })

    const handleFilter = (value, type) => {
        scrollToFilters()
        if (type === 'categories') {
            value = [value]
        }
        const { liked_by, going_to, ..._filter } = filter
        setFilter({ ..._filter, [type]: value })
    }

    const toggleCategory = value => {
        scrollToFilters()
        const { liked_by, going_to, ..._filter } = filter
        if (
            _filter.categories &&
            Array.isArray(_filter.categories) &&
            ~_filter.categories.indexOf(value)
        ) {
            setFilter({
                ..._filter,
                categories: _filter.categories.filter(cat => cat !== value),
            })
        } else {
            let categories =
                (_filter.categories &&
                    Array.isArray(_filter.categories) && [..._filter.categories]) ||
                []
            categories.push(value)
            setFilter({ ..._filter, categories })
        }
    }

    const toggleStatus = value => {
        scrollToFilters()
        const { liked_by, going_to, ..._filter } = filter
        if (_filter.status && Array.isArray(_filter.status) && ~_filter.status.indexOf(value)) {
            setFilter({
                ..._filter,
                status: _filter.status.filter(item_status => item_status !== value),
            })
        } else {
            let status =
                (_filter.status && Array.isArray(_filter.status) && [..._filter.status]) || []
            status.push(value)
            setFilter({ ..._filter, status })
            // console.log('_filter', _filter)
        }
    }

    const handleSort = value => {
        setSort(value)
    }

    const handleSearch = value => {
        setFilter({ ...filter, search: value })
    }

    if (!inAdminPage && filter.status && filter.status.filter(sId => sId !== '5').length > 0) {
        setFilter({ ...filter, status: filter.status.filter(sId => sId === '5') })
    }

    const closed_expired_status = event_status && event_status.find(s => s.event_status_id === '5')

    return (
        <div>
            <div className='filter-container'>
                <div className='container'>
                    {!inAdminPage ? (
                        <Row>
                            <Col className='text-center mt-5 pt-4'>
                                <h2>WELCOME TO THE SOCIAL SIDE OF PLAN.COM</h2>
                                <p>
                                    <strong>Spontaneous fun requires a bit of warning! </strong>
                                    <br />
                                    We all have cats, significant others or personal trainers to
                                    notify if we’re coming home late (or not at all!)
                                </p>
                                <p>
                                    <strong>
                                        plan.play helps you keep your finger on the social pulse.
                                    </strong>
                                    <br />
                                    It’s also your chance to organise your own events – nights out,
                                    choir practice, chess matches, LAN parties...
                                </p>
                                <p>Whatever floats your boat probably floats someone else’s : )</p>
                            </Col>
                        </Row>
                    ) : (
                        <Row className='sp-admin-top-padding' />
                    )}

                    <Form className='sp-filter' onSubmit={e => e.preventDefault()}>
                        <Row>
                            <Col md='3'>
                                <Label for='sp_filter_by' className='sp-filter-label'>
                                    <h2 className='mb-3'>Category:</h2>
                                </Label>
                                {/* <Select id='sp_filter_by' options={filter_by} isMulti={true} /> */}

                                <Input
                                    type='select'
                                    name='sp_filter_by'
                                    id='sp_filter_by'
                                    value={(filter.categories && filter.categories[0]) || ''}
                                    onChange={e => handleFilter(e.target.value, 'categories')}
                                >
                                    <option value=''>All</option>
                                    {(categories &&
                                        Array.isArray(categories) &&
                                        categories.sort(alpha).map(category => (
                                            <option
                                                key={`option-category-${category.id}`}
                                                value={category.id}
                                            >
                                                {category.label}
                                            </option>
                                        ))) ||
                                        null}
                                </Input>
                            </Col>
                            <Col md='3'>
                                <Label for='sp_filter_by' className='sp-filter-label'>
                                    <h2 className='mb-3'>Location:</h2>
                                </Label>
                                <Input
                                    type='select'
                                    name='sp_filter_by'
                                    id='sp_filter_by'
                                    value={filter['location']}
                                    onChange={e => handleFilter(e.target.value, 'location_label')}
                                >
                                    <option value=''>All</option>
                                    {(locations &&
                                        Array.isArray(locations) &&
                                        locations.sort(alpha).map(location => (
                                            <option
                                                key={`option-location-${location.id}`}
                                                value={location.value}
                                            >
                                                {location.label}
                                            </option>
                                        ))) ||
                                        null}
                                </Input>
                            </Col>
                            <Col md='3'>
                                <Label for='sp_order_by' className='sp-filter-label'>
                                    <h2 className='mb-3'>Order by:</h2>
                                </Label>
                                <Input
                                    type='select'
                                    name='sp_order_by'
                                    id='sp_order_by'
                                    value={sort}
                                    onChange={e => handleSort(e.target.value)}
                                >
                                    <option value='RATING'>rating</option>
                                    <option value='NEWEST'>newest</option>
                                    <option value='ENDING_FIRST'>ending first</option>
                                    <option value='COMING_UP'>coming up</option>
                                    <option value='POPULAR'>most popular</option>
                                    <option value='GOING'>people going</option>
                                </Input>
                            </Col>
                            <Col md='3'>
                                <Label for='sp_search_input' className='sp-filter-label'>
                                    <h2 className='mb-3'>Search:</h2>
                                </Label>
                                <Input
                                    type='text'
                                    name='sp_search_input'
                                    id='sp_search_input'
                                    value={(filter && filter.search) || ''}
                                    onChange={e => handleSearch(e.target.value)}
                                />
                            </Col>
                        </Row>

                        <Row className='mt-3'>
                            {categories.map((category, index) => (
                                <div
                                    key={`filter_category_buton_${category.id}`}
                                    className='sp-filter-button col-md-3 text-center mb-3'
                                >
                                    <Button
                                        block
                                        className={
                                            (filter.categories &&
                                                Array.isArray(filter.categories) &&
                                                ~filter.categories.indexOf(category.id) &&
                                                'active') ||
                                            ''
                                        }
                                        onClick={() => toggleCategory(category.id)}
                                    >
                                        {category.label}
                                    </Button>
                                </div>
                            ))}
                        </Row>

                        {inAdminPage ? (
                            <Row className='mt-3'>
                                {event_status.map((status, index) => (
                                    <div
                                        key={`filter_status_buton_${status.event_status_id}`}
                                        className='sp-filter-button col-md-3 text-center mb-3'
                                    >
                                        <Button
                                            block
                                            className={
                                                (filter.status &&
                                                    Array.isArray(filter.status) &&
                                                    ~filter.status.indexOf(
                                                        status.event_status_id,
                                                    ) &&
                                                    'active') ||
                                                ''
                                            }
                                            onClick={() => toggleStatus(status.event_status_id)}
                                        >
                                            {status.event_status_label}
                                        </Button>
                                    </div>
                                ))}
                            </Row>
                        ) : (
                            <Row className='mt-3'>
                                <div className='sp-filter-button col-md-3 text-center mb-3'>
                                    <Button
                                        block
                                        className={
                                            (filter.status &&
                                                Array.isArray(filter.status) &&
                                                ~filter.status.indexOf(
                                                    closed_expired_status.event_status_id,
                                                ) &&
                                                'active') ||
                                            ''
                                        }
                                        onClick={() =>
                                            toggleStatus(closed_expired_status.event_status_id)
                                        }
                                    >
                                        Old Events (closed/expired)
                                    </Button>
                                </div>
                            </Row>
                        )}
                    </Form>
                </div>
            </div>
            <div className='filterresults-container'>
                <div className='section'>
                    <GroupEventCard section={'filter'} number_of_events={12} />
                </div>
            </div>
        </div>
    )
})

const FilterContainer = React.memo(props => {
    return <Filter />
})

export default FilterContainer
